module.exports = __webpack_public_path__ + "img/plus.bdbcfb3c.svg";